import React, { useEffect, useState } from "react";
import { Row, Col, Form, Button } from "react-bootstrap";
import { useNavigate } from "react-router-dom";
import Select from "react-select";
import { LocalizationProvider } from "@mui/x-date-pickers/LocalizationProvider";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import { TimePicker } from "@mui/x-date-pickers/TimePicker";
import dayjs from "dayjs";
import { toast } from "sonner";
import {
  callToast,
  showErrorMessages,
} from "../../../src/services/utilityFunctions.js";
import { useGlobalState } from "../../../src/services/hostelConst";
import { getLocalStorageData } from "../../services/axiosComponent";
import { selectStyle } from "../../services/constant";
import {
  getTutorList,
  getSubjectList,
  getDivisionSectionLectureDetails,
  createDivisionSectionLecture,
  updateDivisionSectionLecture,
  getTutorSubjectsList,
  getDivisionSectionSubjectList,
} from "../../services/Academic-Services.js";
import { closeModal } from "../../services/redux/reducers/modalSlice";
import {
  addSection,
  deleteSection,
} from "../../services/redux/reducers/sectionSlice.js";
import { useDispatch, useSelector } from "react-redux";
const AddLectureToSchedule = ({ navigate, refresh, params }) => {
  const modal = useSelector((state) => state.modal);
  const sectionDetails = useSelector((state) => state.section);
  console.log("Section Details", sectionDetails);
  const dispatch = useDispatch();

  // States for loading indicators
  const [loading, setLoading] = useState(false);
  const [loadingData, setLoadingData] = useState(modal.isEditing);
  const [isTutorOptionsLoading, setIsTutorOptionsLoading] = useState(false);
  const [isSubjectOptionsLoading, setIsSubjectOptionsLoading] = useState(false);

  // Options for select fields
  const [tutorOptions, setTutorOptions] = useState([]);
  const [subjectOptions, setSubjectOptions] = useState([]);

  // Form validation
  const [errors, setErrors] = useState({});

  // Initial form data setup
  const prepareFormData = (data = null) => {
    return {
      name: data != null ? data.NAME : "",
      place: data != null ? data.PLACE : "",

      startTime: data != null ? dayjs(data.START_TIME) : dayjs(),
      endTime: data != null ? dayjs(data.END_TIME) : dayjs().add(1, "hour"),
      tutor: {
        value: data != null ? data._TUTOR : "",
        label: data != null ? data.TUTOR : "",
      },
      subject: {
        value: data != null ? data._SUBJECT : "",
        label: data != null ? data.SUBJECT : "",
      },
    };
  };

  const [formData, setFormData] = useState(prepareFormData());

  // Fetch existing session data if editing
  const getLectureDetails = async (lectureId) => {
    setLoadingData(true);

    // Replace with your actual session details API call
    var res = await getDivisionSectionLectureDetails(lectureId);
    if (res.status == "success") {
      console.log(res, "get session details");
      setFormData(prepareFormData(res.data));
    } else {
      showErrorMessages({ data: res, navigate });
    }
    setLoadingData(false);

    // Dummy data for now
  };

  // Handle form field changes
  const handleChange = (field, value) => {
    setErrors({});
    setFormData((prev) => ({ ...prev, [field]: value }));
  };

  // Form validation
  const validateFields = () => {
    let isValid = true;
    let errors = {};

    if (formData.name === "") {
      isValid = false;
      errors.name = "Session name is required";
    }

    if (formData.place === "") {
      isValid = false;
      errors.place = "Location is required";
    }

    if (formData.tutor.value === "") {
      isValid = false;
      errors.tutor = "Tutor is required";
    }

    if (formData.subject.value === "") {
      isValid = false;
      errors.subject = "Subject is required";
    }

    if (!formData.startTime) {
      isValid = false;
      errors.startTime = "Start time is required";
    }

    if (!formData.endTime) {
      isValid = false;
      errors.endTime = "End time is required";
    } else if (
      formData.startTime &&
      formData.endTime &&
      formData.endTime.isBefore(formData.startTime)
    ) {
      isValid = false;
      errors.endTime = "End time must be after start time";
    }

    setErrors(errors);
    return isValid;
  };
  function convertISOToAMPM(isoString) {
    const date = new Date(isoString);
    let hours = date.getHours();
    const minutes = date.getMinutes().toString().padStart(2, "0");
    const ampm = hours >= 12 ? "PM" : "AM";

    hours = hours % 12;

    hours = hours ? hours : 12;

    const hoursStr = hours.toString().padStart(2, "0");

    return `${hoursStr}:${minutes} ${ampm}`;
  }

  // Form submission
  const handleSubmit = async () => {
    if (validateFields()) {
      setLoading(true);

      // Prepare submission data
      const submitData = {
        name: formData.name,
        place: formData.place,

        startTime: convertISOToAMPM(formData.startTime.toISOString()),
        endTime: convertISOToAMPM(formData.endTime.toISOString()),
        tutorId: formData.tutor.value,
        subjectId: formData.subject.value,
        regionId: sectionDetails._REGION,
        siteId: sectionDetails._SITE,
        scheduleId: params.scheduleId,
        sectionId: sectionDetails._ID,
        organizationId:
          getLocalStorageData("profileDetails")?.["_ORGANIZATION_"]?._ID,
        id: modal.isEditing ? modal.data._ID : null,
      };
      console.log(submitData, "submitData");

      // Replace with your actual API calls
      var res = !modal.isEditing
        ? await createDivisionSectionLecture(submitData)
        : await updateDivisionSectionLecture(submitData);
      if (res.status == "success") {
        callToast(
          "success",
          modal.isEditing ? "Updated" : "Created",
          `Session ${modal.isEditing ? "updated" : "added"} successfully`
        );

        await refresh({ columnRefresh: false, isLoading: false });

        dispatch(closeModal());
      } else {
        showErrorMessages({ data: res, navigate });
      }
      setLoading(false);
      // Simulated API response
    }
  };

  // Fetch tutors
  const getTutorListOptions = async (query = "", subjectId) => {
    setIsTutorOptionsLoading(true);
    var res = await getTutorSubjectsList({
      query: query,
      status: "Y",
      regionId: sectionDetails._REGION,
      siteId: sectionDetails._SITE,
      subjectId: subjectId,
    });
    if (res.status == "success") {
      var list = [];
      console.log(res, "tutor list");
      res.data.entityList.map((item) => {
        list.push({ value: item._TUTOR, label: item.NAME });
      });
      setTutorOptions(list);
    } else {
      showErrorMessages({ data: res, navigate });
    }
    setIsTutorOptionsLoading(false);
  };

  // Fetch subjects
  const getSubjectListOptions = async (query = "") => {
    setIsSubjectOptionsLoading(true);
    setIsTutorOptionsLoading(true);
    var res = await getDivisionSectionSubjectList({
      query: query,
      status: "Y",
      regionId: sectionDetails._REGION,
      siteId: sectionDetails._SITE,
      sectionId: sectionDetails._ID,
    });
    if (res.status == "success") {
      var list = [];
      res.data.entityList.map((item) => {
        list.push({
          value: item._ID,
          label: item.NAME,
          subjectId: item._SUBJECT,
        });
      });
      setSubjectOptions(list);
    } else {
      showErrorMessages({ data: res, navigate });
    }
    setIsTutorOptionsLoading(false);
    setIsSubjectOptionsLoading(false);
  };

  useEffect(() => {
    getSubjectListOptions();

    if (modal.isEditing) {
      getLectureDetails(modal.data._ID);
    }

    return () => {};
  }, []);

  return (
    <>
      {loadingData ? (
        <center>
          <div className="spinner-border text-primary" role="status">
            <span className="sr-only">Loading...</span>
          </div>
        </center>
      ) : (
        <section className="login-content">
          <div className="">
            <div className="d-flex">
              <div className="w-100 ps-4 pe-4">
                <form>
                  <div className="mb-3">
                    <div className="form-row">
                      <div className="col">
                        <label className="form-label">Lecture Name</label>
                        <input
                          type="text"
                          className="form-control"
                          placeholder="Enter Lecture name"
                          value={formData.name}
                          onChange={(e) => handleChange("name", e.target.value)}
                        />
                        {errors.name && (
                          <small className="text-danger">{errors.name}</small>
                        )}
                      </div>
                      <div className="col mt-3">
                        <label className="form-label">Location</label>
                        <input
                          type="text"
                          className="form-control"
                          placeholder="Enter location"
                          value={formData.place}
                          onChange={(e) =>
                            handleChange("place", e.target.value)
                          }
                        />
                        {errors.place && (
                          <small className="text-danger">{errors.place}</small>
                        )}
                      </div>
                    </div>
                  </div>

                  <div className="mb-3">
                    <div className="row">
                      <div className="col-md-6">
                        <label className="form-label">Start Time</label>
                        <LocalizationProvider dateAdapter={AdapterDayjs}>
                          <TimePicker
                            value={formData.startTime}
                            onChange={(newValue) =>
                              handleChange("startTime", newValue)
                            }
                            slotProps={{
                              textField: {
                                fullWidth: true,
                                variant: "outlined",
                                error: !!errors.startTime,
                              },
                            }}
                          />
                        </LocalizationProvider>
                        {errors.startTime && (
                          <small className="text-danger">
                            {errors.startTime}
                          </small>
                        )}
                      </div>
                      <div className="col-md-6">
                        <label className="form-label">End Time</label>
                        <LocalizationProvider dateAdapter={AdapterDayjs}>
                          <TimePicker
                            value={formData.endTime}
                            onChange={(newValue) =>
                              handleChange("endTime", newValue)
                            }
                            slotProps={{
                              textField: {
                                fullWidth: true,
                                variant: "outlined",
                                error: !!errors.endTime,
                              },
                            }}
                          />
                        </LocalizationProvider>
                        {errors.endTime && (
                          <small className="text-danger">
                            {errors.endTime}
                          </small>
                        )}
                      </div>
                    </div>
                  </div>

                  <div className="mb-3">
                    <label className="form-label">Subject</label>
                    <Select
                      styles={selectStyle}
                      options={subjectOptions}
                      value={
                        formData.subject.label === "" ? null : formData.subject
                      }
                      components={
                        isSubjectOptionsLoading ? { DropdownIndicator } : null
                      }
                      onChange={(newValue) => {
                        handleChange(
                          "subject",
                          newValue == null ? { value: "", label: "" } : newValue
                        );
                        getTutorListOptions("", newValue.subjectId);
                      }}
                      onInputChange={(inputValue, { action }) => {
                        if (action === "input-change") {
                          getSubjectListOptions(inputValue);
                        }
                      }}
                      noOptionsMessage={() => "No subjects available"}
                      isSearchable={true}
                      placeholder="Select Subject"
                      className="basic-single"
                      classNamePrefix="select"
                    />
                    {errors.subject && (
                      <small className="text-danger">{errors.subject}</small>
                    )}
                  </div>
                  <div className="mb-3">
                    <label className="form-label">Tutor</label>
                    <Select
                      styles={selectStyle}
                      options={tutorOptions}
                      value={
                        formData.tutor.label === "" ? null : formData.tutor
                      }
                      components={
                        isTutorOptionsLoading ? { DropdownIndicator } : null
                      }
                      onChange={(newValue) => {
                        handleChange(
                          "tutor",
                          newValue == null ? { value: "", label: "" } : newValue
                        );
                      }}
                      onInputChange={(inputValue, { action }) => {
                        if (action === "input-change") {
                          getTutorListOptions(
                            inputValue,
                            formData.subject.subjectId
                          );
                        }
                      }}
                      noOptionsMessage={() => "No tutors available"}
                      isSearchable={true}
                      placeholder="Select Tutor"
                      className="basic-single"
                      classNamePrefix="select"
                    />
                    {errors.tutor && (
                      <small className="text-danger">{errors.tutor}</small>
                    )}
                  </div>

                  <div className="d-flex justify-content-end mt-4 gap-2">
                    <button
                      type="button"
                      className="btn btn-light me-2"
                      onClick={closeModal}
                    >
                      Cancel
                    </button>
                    <button
                      type="button"
                      className="btn btn-primary"
                      onClick={handleSubmit}
                      disabled={loading}
                    >
                      {loading ? (
                        <div
                          className="spinner-border text-light spinner-border-sm"
                          role="status"
                        >
                          <span className="sr-only">Loading...</span>
                        </div>
                      ) : modal.isEditing ? (
                        "Update"
                      ) : (
                        "Submit"
                      )}
                    </button>
                  </div>
                </form>
              </div>
            </div>
          </div>
        </section>
      )}
    </>
  );
};

// Loading indicator for Select components
const DropdownIndicator = (props) => {
  return (
    <div {...props.innerProps}>
      <div
        className="spinner-border text-primary spinner-border-sm m-2"
        role="status"
      >
        <span className="sr-only">Loading...</span>
      </div>
    </div>
  );
};

export default AddLectureToSchedule;
